import { useState } from "react";
import { toast } from "sonner";
import { BANNERS_ADMIN } from "../../data/adminData";
import { PageTitle, Table, Badge, Btn } from "./ui";

export default function Banners() {
  const [list, setList] = useState(BANNERS_ADMIN);
  const toggle = (id) => {
    setList((p) => p.map((b) => (b.id === id ? { ...b, active: !b.active } : b)));
    toast.success("Banera statuss mainīts (DEMO)");
  };
  return (
    <div data-testid="admin-banners">
      <PageTitle right={<Btn variant="red" onClick={() => toast.info("Jauns baneris (DEMO)", { description: "Pilnajā versijā — attēla augšupielāde, saite, grafiks." })} data-testid="banner-add">+ Pievienot baneri</Btn>}>
        Baneri un slaideri ({list.length})
      </PageTitle>
      <Table head={["Baneris", "Pozīcija", "Klikšķi", "Statuss", ""]}>
        {list.map((b) => (
          <tr key={b.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`banner-row-${b.id}`}>
            <td className="p-3 font-bold max-w-[300px]">{b.name}</td>
            <td className="text-[#6B6B6B]">{b.position}</td>
            <td>{b.clicks}</td>
            <td><Badge color={b.active ? "green" : "gray"}>{b.active ? "Aktīvs" : "Izslēgts"}</Badge></td>
            <td className="p-3"><Btn variant="outline" onClick={() => toggle(b.id)} data-testid={`banner-toggle-${b.id}`}>{b.active ? "Izslēgt" : "Ieslēgt"}</Btn></td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
